import { useRef } from 'react';
import { chooseImageDirectory, filesToNameMap, openJsonWithHandle, readJsonFile } from '../lib/fileIo.js';

export default function DataToolbar({
  t,
  lang,
  setLang,
  onLoadJson,
  onSaveSource,
  onExport,
  onSetImageSource,
  fileName,
  hasSourceHandle,
  gemCount,
  dirty,
  setMessage,
}) {
  const jsonInputRef = useRef(null);
  const folderInputRef = useRef(null);

  async function handleOpen() {
    try {
      if ('showOpenFilePicker' in window) {
        const result = await openJsonWithHandle();
        if (result) {
          await onLoadJson(result.data, { handle: result.handle, fileName: result.fileName });
          return;
        }
      }
      jsonInputRef.current?.click();
    } catch (error) {
      if (error?.name !== 'AbortError') setMessage({ type: 'error', text: error.message });
    }
  }

  async function handleFolder() {
    try {
      if ('showDirectoryPicker' in window) {
        const directoryHandle = await chooseImageDirectory();
        if (directoryHandle) {
          onSetImageSource({ directoryHandle, fileMap: null, label: directoryHandle.name });
          setMessage({ type: 'success', text: `이미지 폴더 연결: ${directoryHandle.name}` });
          return;
        }
      }
      folderInputRef.current?.click();
    } catch (error) {
      if (error?.name !== 'AbortError') setMessage({ type: 'error', text: error.message });
    }
  }

  return (
    <div className="data-toolbar">
      <div className="toolbar-group">
        <button onClick={handleOpen}>📂 {t('loadJson')}</button>
        <input
          ref={jsonInputRef}
          type="file"
          accept="application/json,.json"
          hidden
          onChange={async (event) => {
            const file = event.target.files?.[0];
            if (!file) return;
            try {
              const data = await readJsonFile(file);
              await onLoadJson(data, { handle: null, fileName: file.name });
            } catch (error) {
              setMessage({ type: 'error', text: error.message });
            } finally {
              event.target.value = '';
            }
          }}
        />
        <button className="secondary" onClick={handleFolder}>🖼️ {t('imageFolder')}</button>
        <input
          ref={folderInputRef}
          type="file"
          hidden
          multiple
          // Chromium fallback for browsers without File System Access API.
          webkitdirectory=""
          directory=""
          onChange={(event) => {
            const map = filesToNameMap(event.target.files);
            onSetImageSource({ directoryHandle: null, fileMap: map, label: `${map.size} files` });
            setMessage({ type: 'success', text: `이미지 ${map.size}개를 연결했습니다.` });
            event.target.value = '';
          }}
        />
      </div>

      <div className="toolbar-group toolbar-right">
        {gemCount > 0 && (
          <>
            <span className={`file-state ${dirty ? 'dirty' : ''}`}>{dirty ? '● ' : ''}{fileName || 'parsed_gems.json'} · {gemCount.toLocaleString()}</span>
            <button className="secondary" disabled={!hasSourceHandle} onClick={onSaveSource}>💾 {t('saveJson')}</button>
            <button className="secondary" onClick={onExport}>⬇️ {t('exportJson')}</button>
          </>
        )}
        <label className="language-select">
          <span>{t('language')}</span>
          <select value={lang} onChange={(e) => setLang(e.target.value)}>
            <option value="ko">한국어</option>
            <option value="en">English</option>
          </select>
        </label>
      </div>
    </div>
  );
}
